import React from "react";

export const GrabberIcon = ({style = {}}) => {
  return <svg role="img" viewBox="0 0 16 16"  style={{width: 16, height: 16, fill: "white", margin: 3, ...style}} ><path  d="M10 13a1 1 0 100-2 1 1 0 000 2zm-4 0a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 11-2 0 1 1 0 012 0zM6 5a1 1 0 100-2 1 1 0 000 2z"></path></svg>
}
